module.exports = __webpack_public_path__ + "img/SIP_logo_XL.2a82a0bf.png";